class BranchEntryList {
    constructor(rootElement) {
        this.attachEvents(rootElement);
    }

    attachEvents = (rootElement) => {
        const allEntries = [...rootElement.querySelectorAll('.branch-entry-list__entry')];
        const allListItems = [...rootElement.querySelectorAll('.branch-entry-list__list-item')];
        if (allEntries) {
            allEntries.map(((entry) => {
                entry.addEventListener('click', (e) => this.handleEntryButtonOnClick(e, entry, allEntries, allListItems, rootElement))
            }));
        }
    }

    handleEntryButtonOnClick = (e, entry, allEntries, allListItems, rootElement) => {
        e.preventDefault();

        const buttonActiveModifierClass = 'branch-entry-list__entry--active';
        const listItemActiveModifierClass = 'branch-entry-list__list-item--active';

        this.resetActiveStates(allEntries, allListItems, buttonActiveModifierClass, listItemActiveModifierClass);

        const entryId = entry.getAttribute('aria-controls');
        const targetElement = this.activateElement(entry, entryId, buttonActiveModifierClass, listItemActiveModifierClass);

        if (targetElement) {
            this.activateCounterpart(entryId, rootElement, buttonActiveModifierClass, listItemActiveModifierClass);
        }
    };

    resetActiveStates = (allEntries, allListItems, buttonClass, listItemClass) => {
        allListItems.forEach(item => {
            item.classList.remove(listItemClass);
            item.setAttribute('aria-hidden', true);
        });

        allEntries.forEach(item => {
            item.classList.remove(buttonClass);
            item.setAttribute('aria-expanded', false);
        });
    };

    activateElement = (entry, entryId, buttonClass, listItemClass) => {
        const targetElement = document.getElementById(entryId);

        if (targetElement) {
            targetElement.classList.add(listItemClass);
            targetElement.setAttribute('aria-hidden', false);

            entry.classList.add(buttonClass);
            entry.setAttribute('aria-expanded', true);
        }

        return targetElement;
    };

    activateCounterpart = (entryId, rootElement, buttonClass, listItemClass) => {
        const counterpartId = entryId.includes('desktop')
            ? entryId.replace('desktop', 'mobile')
            : entryId.replace('mobile', 'desktop');

        const counterpartElement = rootElement.querySelector(`#${counterpartId}`);
        const counterpartButton = rootElement.querySelector(
            `.branch-entry-list__entry${entryId.includes('desktop') ? '--mobile' : ''}[aria-controls="${counterpartId}"]`
        );

        if (counterpartElement) {
            counterpartElement.classList.add(listItemClass);
            counterpartElement.setAttribute('aria-hidden', false);
        }

        if (counterpartButton) {
            counterpartButton.classList.add(buttonClass);
            counterpartButton.setAttribute('aria-expanded', true);
        }
    };
}

document.addEventListener('DOMContentLoaded', function () {
    const branchEntryLists = [...document.querySelectorAll('.branch-entry-list')];
    branchEntryLists.map((rootElement) => {
        new BranchEntryList(rootElement)
    })
});